import type { CartItem } from '~api/tos';

export class Format {
  static Id(id: string) {
    const countLength = id.length;
    const first = id.substring(0, 4);
    const last = id.substring(countLength - 4, countLength);
    const truncatedId = `${first} ... ${last}`;
    const truncateSince = 12;

    return countLength >= truncateSince ? truncatedId : id;
  }

  static TotalQuantity(cartItems: CartItem[]) {
    return cartItems.reduce((total, item) => total + (item.quantity ?? 0), 0);
  }

  static TotalWeight(cartItems: CartItem[]) {
    return cartItems.reduce((total, item) => total + (item.weight ?? 0) * (item.quantity ?? 1), 0);
  }
}
